import React from 'react';
import { useIntl } from 'react-intl';

import NoStages from '../../../../../../assets/image/NoStages.svg';
import './NoCarbonData.scss';

const NoCarbonData = () => {
  const translate = useIntl();
  return (
    <div className="noCarbon__wrapper">
      {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
      <img src={NoStages} alt="No carbon data image" />
      <div className="noCarbon__text">
        {translate.formatMessage({ id: 'carbon.placeholder.nodata' })}
      </div>
    </div>
  );
};

export default NoCarbonData;
